/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { useSelector, useDispatch } from "react-redux";
import { Box, Grid, Typography } from "@mui/material";

import { useStyles } from "./styles";
import { TITLES } from "./constants";
import interpolateString from "../../utility/stringInterpolation";
import { selectSelectedModule } from "../../store/module/moduleSelector";
import { SNACKBAR_ALERT_DEFAULT_PROPS } from "../../shared/constants";
import { setSnackBarDisplay } from "../../store/snackBar/snackBarActionCreator";
import DisplayContent from "../../shared/displayContent/DisplayContent";

const ModuleDetails = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const selectedModule = useSelector(selectSelectedModule);

  const displaySnackbar = (name: string, severity: "success" | "error") => {
    dispatch(
      setSnackBarDisplay({
        ...SNACKBAR_ALERT_DEFAULT_PROPS,
        show: true,
        message: interpolateString([name], TITLES.COPIED_TO_CLIPBOARD),
        severity: severity,
      })
    );
  };
  const hideSnackbar = () => {
    dispatch(
      setSnackBarDisplay({
        ...SNACKBAR_ALERT_DEFAULT_PROPS,
        show: false,
      })
    );
  };

  const showHideSnackbar = (name: string) => {
    hideSnackbar();
    displaySnackbar(name, "success");
  };
  return (
    <Grid
      container
      className={selectedModule?.id ? classes.root : classes.hide}
    >
      <Grid item xs={12}>
        <DisplayContent
          testId="moduleName"
          data-testid="moduleName"
          content={selectedModule?.name || "N/A"}
          contentText={TITLES.MODULE_NAME}
          handleCopyClick={() => showHideSnackbar(TITLES.MODULE_NAME)}
        />
      </Grid>
      <Grid item xs={12}>
        <DisplayContent
          testId="moduleKey"
          data-testid="moduleKey"
          content={selectedModule?.moduleKey || "N/A"}
          contentText={TITLES.MODULE_KEY}
          handleCopyClick={() => showHideSnackbar(TITLES.MODULE_KEY)}
        />
      </Grid>
      <Grid item xs={12}>
        <DisplayContent
          testId="serviceId"
          data-testid="serviceId"
          content={selectedModule?.serviceId || "N/A"}
          contentText={TITLES.SERVICE_ID}
          handleCopyClick={() => showHideSnackbar(TITLES.SERVICE_ID)}
        />
      </Grid>
      <Grid item xs={12}>
        <DisplayContent
          testId="description"
          data-testid="description"
          content={selectedModule?.description || "N/A"}
          contentText={TITLES.MODULE_DESCRIPTION}
        />
      </Grid>
    </Grid>
  );
};

export default ModuleDetails;
